module.exports = __webpack_public_path__ + "img/w3_filter_light.4d531159.png";